import httpUtils from '../../utils/HttpUtils'

class RecommendGroupMemberService {

  //获取推荐工长
  async get(appointmentId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/recommend/group/member/get',{appointmentId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new RecommendGroupMemberService()
